import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function SomethingWentWrongIndicator({ error }) {
  return (
    <React.Fragment>
      <div className="error-wrapper">
        <div style={{color: "blue"}}>
          <FontAwesomeIcon style={{color: 'red'}} icon='exclamation'/>{' '}Something went wrong. Please try again..
        </div>
        <div style={{color: "red"}}> [{error.message}]</div>
      </div>
      <style jsx="true">
        {`
          .error-wrapper {
            display: flex;
            flex-direction: column;
          }
        `}
      </style>
    </React.Fragment>
  )
}

export default SomethingWentWrongIndicator
